/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, OnInit, EventEmitter, Input, OnDestroy, Output, ViewEncapsulation, TemplateRef, ViewChild } from "@angular/core";
import { IUserAccount, Page, IResource, ProgressData } from "@shared/models";
import { AppData, HttpService, NotifyService, ResourceService } from "@shared/services";
import { takeUntil, finalize } from "rxjs/operators";
import { LabParameterInputModel, LabComponentHeaderForInput, LabParameterInputHeaderModel, LabTransferModel, LabStatusModel, LabParameterGroup, LabTemplateHeaderForInput, LabBillDetailModel, LabPastReportsModel } from "@admin/labs/pages/models";
import { ApiResources, UtilHelper, LinqHelper } from "@shared/helpers";
import { forkJoin } from "rxjs";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ProviderSpecialization } from "../../entities/provider-specialization.entity";
import { LabReportSignature } from "../../../areas/admin/labs/pages/models/lab-report-signature";
import { DomSanitizer } from "@angular/platform-browser";
import { LabObservedValueModel } from "../../../areas/admin/labs/pages/models/lab-observedValue.model";
import { HttpErrorResponse } from "@angular/common/http";
import { LabDocumentsDetails } from "../../entities/laboratory/lab-document-details.entity";
import { ModalType } from "@shared/enums";
import { Pagination } from "@shared/models";
import { LookUpValue } from "../../entities";
import { Router } from "@angular/router";
import { Doctors } from "../../../areas/admin/labs/pages/models/verified-tests-model";



class TemplateInput {
    newLabBookingDetailId: number;
    labTemplateObservedValueId: number;
    labTemplateHeaderId: number;
    isMethod: boolean;
    methodText: string;
    isInterpretation: boolean;
    interpretationText: string;
    labMainDetailId: number;
}

class Age {
    year: number;
    month: number;
    day: number;
}


class TempParameter {
    labParameterObservedValueId?: number;
    labComponentHeaderId: number;
    componentName: string;
    labTemplateHeaderId: number;
    templateName: string;
    labParameterHeaderId: number;
    parameterName: string;
    displayName: string;
    referenceOutput: string;
    observedValue: string;
    templateCount: number;
    componentCount: number;
    labParameterDetailId?: number;
    labAntibioticsId?: number;
}

@Component({
    templateUrl: "./new-lab-parameter.html",
    selector: "new-lab-parameter",
    styleUrls: ['./new-lab-parameter.css'],
    encapsulation: ViewEncapsulation.None
})

export class NewLabParameterWidget implements OnInit, OnDestroy {
    @ViewChild("#templateReport", { static: true }) templateReport: TemplateRef<any>;
    @Input() newLabBookingDetailId: number;
    @Input() encryptedNewLabBookingDetailId: string;
    @Output() onClose = new EventEmitter<any>();
    @Input() isPrintLogo: boolean;
    @Input() isValidation: boolean;
    @Input() showTechnitionVerify: boolean;
    @Input() showDoctorVerify: boolean;
    @Input() resultsType: string;
    page: Page;
    loading: boolean;
    parameters: LabParameterInputModel;
    reports: LabParameterInputModel;
    submitting: boolean;
    submitted: boolean;
    templateInput: Array<TemplateInput>;
    parameterInput: Array<TempParameter>;
    loadingSample: boolean;
    demographData: Array<LabTransferModel>;
    showLabDocument: boolean;
    loadingTimeline: boolean;
    timeline: Array<LabStatusModel>;
    labAntibiotics: Array<LabParameterInputHeaderModel>;

    modalRef: NgbModalRef;
    selectedParameter: LabParameterInputHeaderModel
    currentDate: Date;
    notesEditor = ClassicEditor;
    config = {
        placeholder: "Enter your content here!",
        toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote"]
    };
    age: Age;
    loadingProviders: boolean;
    providers: Array<IResource>;
    //provider: IResource;
    providerAssigningForm: FormGroup;
    providerSpecialization: Array<ProviderSpecialization>;
    reportSignatures: Array<LabReportSignature>;
    loadingDoctorSignatures: boolean;
    provideredit: boolean;
    providerAssigned: Array<LabReportSignature>;
    loadingproviderAssigning: boolean;
    sendpatientId: string;
    doctorDropDown: boolean;
    loadingObservedValues: boolean;
    totalObservedValues: Array<LabObservedValueModel>;
    totalObservedValues2: any;
    parameterNames: any;
    showLabReport: boolean;
    fileUploadFail: boolean;
    loadingFile: boolean;
    uploadedFile: File;
    fileName: string;
    formedUrl: any;
    documentError: boolean;
    selectedLabBookingDetail: LabBillDetailModel;
    isUploading: boolean;
    techForm: FormGroup;
    isVerify: boolean;
    doctorAssigned: boolean;

    checkExternal: LabBillDetailModel;
    isExternalDocument: boolean;
    isExternalLoading: boolean;
    reportDataWithoutAuth: string;
    reportData: any;
    loadingDocument: boolean;
    records: LabBillDetailModel;
    documentUrl: string;
    errorMessage: any;
    parametersDummy: LabParameterInputModel;
    showButton = true;
    isAbnormal: boolean;
    modalRefViewDocument: NgbModalRef;
    patientId: number;
    warningMessage: string;
    files: Array<File>;
    maxFiles = 10;
    modalRefDocument: NgbModalRef;
    documents: Array<LabDocumentsDetails>;
    labAntibioticsResultTypes: Array<LookUpValue>;
    document: LabDocumentsDetails;
    showPrevious: boolean;
    showNext: boolean;
    documentName: string;
    pagination: Pagination;
    modifyingContent: string;
    modifying: boolean;
    encryptedPatientId: string;
    modalRefView: NgbModalRef;
    uploadForm: FormGroup;
    showReport: boolean;
    selectParameter: string;
    reportsDummy: LabParameterInputModel;
    patientPastLabReports: LabPastReportsModel[];
    loadingPastLabReports: boolean;
    labMainDetailId: number;
    pagination1: Pagination;
    verifying: boolean;
    doctorDetails: Doctors;
    isHaveParameters: boolean;
    reason: string;
    modalReason: NgbModalRef;
    constructor(
        private readonly appData: AppData,
        private readonly httpService: HttpService,
        private readonly modalService: NgbModal,
        private readonly notifyService: NotifyService,
        private readonly resourceService: ResourceService,
        private readonly formBuilder: FormBuilder,
        private readonly sanitizer: DomSanitizer,
        private readonly router: Router,

    ) {
        this.page = new Page();
        this.doctorAssigned = false;
        this.doctorDropDown = false;
        this.provideredit = false;
        this.parameters = new LabParameterInputModel();
        this.templateInput = new Array<TemplateInput>();
        this.demographData = new Array<LabTransferModel>();
        this.timeline = new Array<LabStatusModel>();
        this.selectedParameter = new LabParameterInputHeaderModel();
        this.age = new Age();
        this.providers = new Array<IResource>();
        this.buildProviderAssigningForm();
        this.providerSpecialization = new Array<ProviderSpecialization>();
        this.reportSignatures = new Array<LabReportSignature>();
        this.totalObservedValues = new Array<LabObservedValueModel>();
        this.labAntibioticsResultTypes = new Array<LookUpValue>();
        this.reports = new LabParameterInputModel();
        this.showLabReport = false;
        this.showLabDocument = false;
        this.selectedLabBookingDetail = new LabBillDetailModel();
        this.initPagination();
        this.initPagination1();
        this.reportsDummy = new LabParameterInputModel();
        this.labAntibiotics = new Array<LabParameterInputHeaderModel>();

    }
    private initPagination() {
        this.pagination = new Pagination();
        this.pagination.pageIndex = 1;
        this.pagination.pageSize = 12;
    }
    safe = (url: any) => {
        if (url) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${url}`);
        }
    }
    onCloseModel() {
        this.onClose.emit();
    }

    private onFetchDemographData() {
        this.loadingSample = true;
        const request = {
            //  newLabBookingDetailId: this.newLabBookingDetailId
            encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId
        };
        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchReceivedLabs), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingSample = false))
            .subscribe((response: Array<LabTransferModel>) => {
                this.demographData = response;
                this.fetchDocuments();
                this.sendpatientId = this.demographData[0].encryptedId;
                var selectedDemographData = this.demographData ? this.demographData.find(x => x.encryptedNewLabBookingDetailId == this.encryptedNewLabBookingDetailId) : null;
                this.newLabBookingDetailId = selectedDemographData ? selectedDemographData.newLabBookingDetailId : null;
                this.callwhenAfterProvidersLoaded(this.newLabBookingDetailId);
                this.fetchNewLabBookingDetail();
                if (UtilHelper.isEmpty(this.demographData[0].dateOfBirth)) {
                    let mdob = moment(this.demographData[0].dateOfBirth, "YYYY-MM-DD");
                    let age = moment().diff(mdob, "months");
                    let yrs = (age / 12).toFixed(1);
                    let months = age % 12;
                    let days = moment().diff(mdob.add(yrs, 'years'), 'days', false);
                    this.age.day = days;
                    this.age.year = parseInt(yrs, 10);
                    this.age.month = months;
                    let date1 = moment(this.demographData[0].dateOfBirth, "YYYY-MM-DD");
                    let monthsa = moment().diff(date1, 'months');
                    date1.add(monthsa, 'months');
                    let daysa = moment().diff(date1, 'days');
                    monthsa + ' ' + 'Month(s)' + ' ' + daysa + " Day(s)"
                    this.age.day = daysa;
                } else {
                    this.age = new Age();
                }
            });
    }

    private onFetchInputParameters() {
        const request = {
            //newLabBookingDetailId: this.newLabBookingDetailId,
            encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId,
            fromTech: "tech"
        };
        this.loading = true;
        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.labParameterForInput), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: LabParameterInputModel) => {
                this.parameters = response;
                this.labMainDetailId = this.parameters.labMainDetailId;
                this.reports = new LabParameterInputModel();
                this.reports = UtilHelper.clone(this.parameters);
                this.reports.templates = new Array<LabTemplateHeaderForInput>();
                this.parameters.templates.forEach((template: LabTemplateHeaderForInput) => {
                    let parameterList = new Array<LabParameterInputHeaderModel>();
                    template.components.forEach((component: LabComponentHeaderForInput) => {
                        component.parameters.forEach((param: LabParameterInputHeaderModel) => {
                            if (param.observedValue != null && param.observedValue != "") {
                                this.isHaveParameters = true;
                            }
                            if (param.observedValue == "" || !param.observedValue) {
                                param.showText = null;
                                param.isBold = false;
                            } else {
                                let observedValue = +param.observedValue;
                                let range = param.selected;
                                if (range != null) {
                                    let exactRange = range;
                                    if (exactRange.minValue > observedValue) {
                                        param.showText = "L";
                                        param.isBold = true;
                                        this.isAbnormal = true;
                                    }
                                    else if (observedValue > +exactRange.maxValue) {
                                        param.showText = "H";
                                        param.isBold = true;
                                        this.isAbnormal = true;
                                    }
                                }
                            }
                            if (param.type == "Regular") {
                                if (param.observedValue == null && param.defaultValue != null) {
                                    if (UtilHelper.isEmpty(param.defaultValue.trim())) {
                                        param.observedValue = param.defaultValue;
                                    }
                                }
                                parameterList.push(param);
                            }
                            else if (param.type == "Microbiology") {
                                var resultAddedAntibiotics = param.antibiotics.filter(x => x.observedValue != null);
                                if (resultAddedAntibiotics.length > 0) {
                                    this.isHaveParameters = true;
                                    param.antibiotics = resultAddedAntibiotics;
                                    parameterList.push(param);
                                } else {
                                    parameterList.push(param);
                                }

                            }
                        });
                    });
                    template.parameters.forEach((param: LabParameterInputHeaderModel) => {
                        if (param.observedValue != null && param.observedValue != "") {
                            this.isHaveParameters = true;
                        }
                        if (param.observedValue == "" || !param.observedValue) {
                            param.showText = null;
                            param.isBold = false;
                        } else {
                            let observedValue = +param.observedValue;
                            let range = param.selected;
                            if (range != null) {
                                let exactRange = range;
                                if (exactRange.minValue > observedValue) {
                                    param.showText = "L";
                                    this.isAbnormal = true;
                                    param.isBold = true;
                                }
                                else if (observedValue > +exactRange.maxValue) {
                                    param.showText = "H";
                                    this.isAbnormal = true;
                                    param.isBold = true;
                                }
                            }
                        }
                        if (param.type == "Regular") {
                            if (param.observedValue == null && param.defaultValue != null) {
                                if (UtilHelper.isEmpty(param.defaultValue.trim())) {
                                    param.observedValue = param.defaultValue;
                                }
                            }
                            parameterList.push(param);
                        }
                        else if (param.type == "Microbiology") {
                            var resultAddedAntibiotics = param.antibiotics.filter(x => x.observedValue != null);
                            if (resultAddedAntibiotics.length > 0) {
                                param.antibiotics = resultAddedAntibiotics;
                                this.isHaveParameters = true;
                                parameterList.push(param);
                            } else {
                                parameterList.push(param);
                            }

                        }
                    });
                    //let templateToAssign = UtilHelper.clone(template) as LabTemplateHeaderForInput;

                    //templateToAssign.components = new Array<LabComponentHeaderForInput>();
                    //templateToAssign.parameters = new Array<LabParameterInputHeaderModel>();
                    //LinqHelper.sort(parameterList, "displayOrder");
                    //templateToAssign.parameters = parameterList;
                    this.reports.templates.push(template);
                });
            });
    }

    onSubmit() {
        const BreakError = {};
        const req2 = {
            newLabBookingDetailId: this.newLabBookingDetailId,
        };
        //if (this.page.userAccount.roleId == 3) {
        //    req2["doctorId"] = this.page.userAccount.referenceId;
        //    req2["accountId"] = this.page.userAccount.accountId;
        //}
        req2["patientId"] = this.demographData[0].patientId;
        req2["urlLink"] = window.location.href;
        req2["testName"] = this.demographData[0].testName;
        let sampleNum = 0;
        if (this.demographData[0].status != this.demographData[0].subStatus) {
            let sampleNumber = this.demographData[0] && UtilHelper.isEmpty(this.demographData[0].sampleName) ? this.demographData[0].sampleName.split(" ") : new Array<string>();
            if (sampleNumber.length > 0) {
                sampleNum = +sampleNumber[1];
            }
        }
        try {

            const templates = this.parameters.templates;
            this.parameterInput = new Array<TempParameter>();
            this.templateInput = new Array<TemplateInput>();
            templates.forEach((template) => {
                if (template.isMethod) {
                    if (UtilHelper.isEmpty(template.methodText) && UtilHelper.isEmpty(template.methodText.trim())) {
                        // ignore
                    } else {
                        this.notifyService.warning(`Please enter method text for template ${template.templateName}`);
                        throw BreakError;
                    }
                }
               
                let param = 0;
                template.components.forEach((component: LabComponentHeaderForInput) => {
                    var abnormalIndex = component.parameters.findIndex(param => param.showText == "H" || param.showText == "L");
                    if (abnormalIndex > -1) {
                        this.isAbnormal = true;
                    } else {
                        this.isAbnormal = false;
                    }
                    component.parameters.forEach((parameter: LabParameterInputHeaderModel) => {
                        let model = new TempParameter();
                        model.labComponentHeaderId = component.labComponentHeaderId;
                        model.labTemplateHeaderId = template.labTemplateHeaderId;
                        model.templateName = template.templateName;
                        model.labParameterHeaderId = parameter.labParameterHeaderId;
                        model.parameterName = parameter.parameterName;
                        model.referenceOutput = parameter.referenceOutput;
                        param = param + 1;
                        if (this.isValidation) {
                            if (parameter.type === "Regular") {
                                if (this.demographData[0].status != this.demographData[0].subStatus && sampleNum > 0 && sampleNum >= param) {
                                    if (!UtilHelper.isEmpty(parameter.observedValue)) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                        throw BreakError;
                                    }
                                    else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                        throw BreakError;
                                    }
                                }
                                else if (this.demographData[0].status === this.demographData[0].subStatus) {
                                    if (!UtilHelper.isEmpty(parameter.observedValue)) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                        throw BreakError;
                                    }
                                    else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                        throw BreakError;
                                    }
                                }
                            }
                            else {
                                parameter.antibiotics.forEach((antibiotic: LabParameterInputHeaderModel) => {
                                    if (this.demographData[0].status != this.demographData[0].subStatus && sampleNum > 0 && sampleNum >= param) {
                                        if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${antibiotic.antibioticName}`);
                                            throw BreakError;
                                        }
                                        else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${antibiotic.antibioticName}`);
                                            throw BreakError;
                                        }
                                    }
                                    else if (this.demographData[0].status === this.demographData[0].subStatus) {
                                        if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${antibiotic.antibioticName}`);
                                            throw BreakError;
                                        }
                                        else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${antibiotic.antibioticName}`);
                                            throw BreakError;
                                        }
                                    }
                                });
                            }

                        }


                        if (parameter.type === "Regular") {
                            if (this.isValidation) {
                                if (!UtilHelper.isEmpty(parameter.observedValue)) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                    throw BreakError;
                                }
                                else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                    throw BreakError;
                                }
                            }
                            model.observedValue = parameter.observedValue;
                            model.labParameterObservedValueId = parameter.labParameterObservedValueId;
                            model.labParameterDetailId = parameter.labParameterDetailId;
                            this.parameterInput.push(model);



                        }
                        else {
                            parameter.antibiotics.forEach((antibiotic: LabParameterInputHeaderModel) => {
                                if (this.isValidation) {
                                    if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${antibiotic.antibioticName}`);
                                        throw BreakError;
                                    }
                                    else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${antibiotic.antibioticName}`);
                                        throw BreakError;
                                    }
                                }
                                let tempModel = new TempParameter();
                                tempModel.labComponentHeaderId = 0;
                                tempModel.labTemplateHeaderId = template.labTemplateHeaderId;
                                tempModel.templateName = template.templateName;
                                tempModel.labParameterHeaderId = parameter.labParameterHeaderId;
                                tempModel.parameterName = parameter.parameterName;
                                tempModel.observedValue = antibiotic.observedValue;
                                tempModel.labAntibioticsId = antibiotic.labAntibioticsId;
                                tempModel.labParameterObservedValueId = antibiotic.labParameterObservedValueId;
                                tempModel.labComponentHeaderId = component.labComponentHeaderId;
                                if (UtilHelper.isEmpty(antibiotic.observedValue)) {
                                    if (UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                        this.parameterInput.push(tempModel);
                                    }
                                }
                            });
                        }
                    });
                });
                param = 0;
                var abnormalIndex = template.parameters.findIndex(param => param.showText == "H" || param.showText == "L");
                if (abnormalIndex > -1) {
                    this.isAbnormal = true;
                } else {
                    this.isAbnormal = false;
                }
                template.parameters.forEach((parameter: LabParameterInputHeaderModel) => {
                    let model = new TempParameter();
                    model.labComponentHeaderId = 0;
                    model.labTemplateHeaderId = template.labTemplateHeaderId;
                    model.templateName = template.templateName;
                    model.labParameterHeaderId = parameter.labParameterHeaderId;
                    model.parameterName = parameter.parameterName;
                    model.referenceOutput = parameter.referenceOutput;

                    param = param + 1;
                    if (this.isValidation) {
                        if (parameter.type === "Regular") {
                            if (this.demographData[0].status != this.demographData[0].subStatus && sampleNum > 0 && sampleNum >= param) {
                                if (!UtilHelper.isEmpty(parameter.observedValue)) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                    throw BreakError;
                                }
                                else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                    throw BreakError;
                                }
                            }
                            else if (this.demographData[0].status === this.demographData[0].subStatus) {
                                if (!UtilHelper.isEmpty(parameter.observedValue)) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                    throw BreakError;
                                }
                                else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                    throw BreakError;
                                }
                            }

                        }
                        else {
                            parameter.antibiotics.forEach((antibiotic: LabParameterInputHeaderModel) => {
                                if (this.demographData[0].status != this.demographData[0].subStatus && sampleNum > 0 && sampleNum >= param) {
                                    if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                        throw BreakError;
                                    }
                                    else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                        throw BreakError;
                                    }
                                }
                                else if (this.demographData[0].status === this.demographData[0].subStatus) {
                                    if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                        throw BreakError;
                                    }
                                    else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                        throw BreakError;
                                    }
                                }
                            });

                        }
                    }

                    if (parameter.type === "Regular") {
                        if (this.isValidation) {
                            if (!UtilHelper.isEmpty(parameter.observedValue)) {
                                this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                throw BreakError;
                            }
                            else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                                this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                throw BreakError;
                            }
                        }
                        model.observedValue = parameter.observedValue;
                        model.labParameterObservedValueId = parameter.labParameterObservedValueId;
                        model.labParameterDetailId = parameter.labParameterDetailId;
                        this.parameterInput.push(model);
                    }
                    else {
                        parameter.antibiotics.forEach((antibiotic: LabParameterInputHeaderModel) => {
                            if (this.isValidation) {
                                if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                    throw BreakError;
                                }
                                else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                    throw BreakError;
                                }
                            }
                            let tempModel = new TempParameter();
                            tempModel.labComponentHeaderId = 0;
                            tempModel.labTemplateHeaderId = template.labTemplateHeaderId;
                            tempModel.templateName = template.templateName;
                            tempModel.labParameterHeaderId = parameter.labParameterHeaderId;
                            tempModel.parameterName = parameter.parameterName;
                            tempModel.observedValue = antibiotic.observedValue;
                            tempModel.labAntibioticsId = antibiotic.labAntibioticsId;
                            tempModel.labParameterObservedValueId = antibiotic.labParameterObservedValueId;
                            if (UtilHelper.isEmpty(antibiotic.observedValue)) {
                                if (UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                    this.parameterInput.push(tempModel);
                                }
                            }
                        });
                    }
                });

                const templateToPush = {
                    labTemplateObservedValueId: template.labTemplateObservedValueId || 0,
                    newLabBookingDetailId: this.newLabBookingDetailId,
                    labTemplateHeaderId: template.labTemplateHeaderId,
                    isMethod: template.isMethod,
                    methodText: template.methodText,
                    isInterpretation: template.isInterpretation,
                    interpretationText: template.interpretationText,
                    labMainDetailId: this.parameters.labMainDetailId
                };
                if (template.isInterpretation || template.isMethod) {
                    this.templateInput.push(templateToPush);
                }
            });
            this.submitting = true;
            let requestApi = new Array<any>();
            if (this.parameterInput.length > 0) {
                const parameterRequest = {
                    newLabBookingDetailId: this.newLabBookingDetailId,
                    parameters: this.parameterInput,
                    createdBy: this.page.userAccount.accountId,
                    locationId: this.page.userAccount.locationId,
                    isAbnormal: this.isAbnormal
                }
                let parameterApi = this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.addLabParameterInput), parameterRequest);
                requestApi.push(parameterApi);
            }
            if (this.templateInput.length > 0) {
                const templateRequest = {
                    newLabBookingDetailId: this.newLabBookingDetailId,
                    templates: this.templateInput,
                    createdBy: this.page.userAccount.accountId,
                    locationId: this.page.userAccount.locationId
                }
                let templateApi = this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.addTemplateInput), templateRequest);
                requestApi.push(templateApi);
            }
            //if (this.page.userAccount.roleId == 3) {
            //    let doctorVerifyApi = this.httpService.post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.doctorVerifyReport), req2);
            //    requestApi.push(doctorVerifyApi);
            //}
            forkJoin([...requestApi])
                .pipe(takeUntil(this.page.unSubscribe))
                .pipe(finalize(() => this.submitting = false))
                .subscribe((response: Array<any>) => {
                    if (response[0] as number > 0 && response[1] as number > 0) {
                        this.notifyService.successToast("Labs Parameters and Templates added successfully.");
                    }
                    else if (response[0] as number > 0) {
                        this.notifyService.successToast("Labs Parameters modified successfully.");
                    }
                    else if (response[1] as number > 0) {
                        this.notifyService.successToast("Labs Templates modified successfully.");
                    }
                    if (!this.isVerify) {
                        this.onCloseModel();
                    } else {
                        this.onVerifyByTechnician();
                        this.isVerify = false;
                        this.onCloseModel();
                    }
                }, () => {
                    this.notifyService.defaultErrorToast();
                });
            if (this.page.userAccount.roleId == 3) {
                this.onDoctorVerified();
            }
        } catch (err) {
            if (err !== BreakError) throw err;
        }

    }

    private fetchTimeline() {
        //let abc = decodeURIComponent(this.encryptedNewLabBookingDetailId);
        const request = {
            newLabBookingHeaderId: "",
            newLabBookingDetailId: this.newLabBookingDetailId,
            encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId,

        };
        this.loadingTimeline = true;
        this.httpService.get(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchLabTimeline), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingTimeline = false))
            .subscribe((response: Array<LabStatusModel>) => {
                this.timeline = response;
            }, () => {
                this.notifyService.warningToast("Unable to fetch lab timeline.");
            });
    }

    onOpenForParameterSelection(content: TemplateRef<any>, data: LabParameterInputHeaderModel) {
        this.selectedParameter = data;
        this.onOpenModel(content, "xl");
    }

    onSelectParameter(selectedValue: LabParameterGroup) {
        this.selectedParameter.labParameterDetailId = selectedValue.labParameterDetailId;
        this.selectedParameter.selected = selectedValue;
        this.onCloseModal();
    }

    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    this.onFetchInputParameters();
                    this.onFetchDemographData();
                    this.fetchTimeline();

                    this.fetchLabBookingDetail();
                    this.fetchNewLabBookingDetail();

                    this.fetchLabBookingDetail()
                    this.FetchInputParameters();
                    this.findLabAntibiotic();
                    this.fetchAntibioticResultTypes();
                    //if (this.page.userAccount.roleId == 3) {
                    //    this.fetchDoctorVerifyDetail();
                    //}
                } else {
                    this.page.userAccount = undefined;
                }
            });
    }

    onOpenModel(content: TemplateRef<any>, size: string) {
        this.modalRef = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            size: size,
            windowClass: "custom-modal effect-scale"
        });
    }

    onCloseModal() {
        try {
            this.modalRef.close();
            this.modalRef = undefined;
            this.totalObservedValues2 = null;
            this.totalObservedValues = null;

        } catch (e) {
            // ignored;
        }
        this.isVerify = false;
    }

    ngOnDestroy() {
        this.onCloseExtraPopup();
        this.onCloseModal();
        this.onCloseModel();
        this.page.unsubscribeAll();
    }

    onViewReport(content: TemplateRef<any>) {
        this.reports = new LabParameterInputModel();
        this.reports = UtilHelper.clone(this.parameters);
        this.reports.templates = new Array<LabTemplateHeaderForInput>();
        this.parameters.templates.forEach((template: LabTemplateHeaderForInput) => {
            let parameterList = new Array<LabParameterInputHeaderModel>();
            template.components.forEach((component: LabComponentHeaderForInput) => {
                component.parameters.forEach((param: LabParameterInputHeaderModel) => {
                    parameterList.push(param);
                });
            });
            template.parameters.forEach((param: LabParameterInputHeaderModel) => {
                parameterList.push(param);
            });
            let templateToAssign = UtilHelper.clone(template) as LabTemplateHeaderForInput;

            templateToAssign.components = new Array<LabComponentHeaderForInput>();
            templateToAssign.parameters = new Array<LabParameterInputHeaderModel>();
            LinqHelper.sort(parameterList, "displayOrder");
            templateToAssign.parameters = parameterList;
            this.reports.templates.push(templateToAssign);
        });

        this.onOpenModel(content, "xl");
        this.currentDate = new Date();
        this.loadingDoctorSignatures = true;
        /* this.httpService.get(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchDoctorSignature), { newLabBookingDetailId: this.newLabBookingDetailId })*/
        this.httpService.get(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchDoctorSignature), { encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingDoctorSignatures = false))
            .subscribe((response: Array<LabReportSignature>) => {
                response.forEach(x => {
                    x["newSignature"] = x.signature ? this.safe(x.signature) : null;
                })
                this.reportSignatures = response;
                //this.router.navigate([]).then(() => { window.open(`${location.origin}${location.pathname}#/app/labs/patient-lab-report/${this.newLabBookingDetailId}`, "_blank"); });
                //This Below one will Work.
                //this.router.navigate([]).then(() => { window.open(`${location.origin}${location.pathname}#/new-lab-reports/${this.newLabBookingDetailId}`, "_blank"); });
            }, () => {
                this.notifyService.warningToast("Unable to Doctor signature.");
            });

    }
    fetchProviders() {
        this.loadingProviders = true;
        this.resourceService.pathologyProviders()
            .pipe(finalize(() => { this.loadingProviders = false }))
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((response: Array<IResource>) => {
                this.providers = response;
            });
    }
    selectDoctor(content: TemplateRef<any>) {
        this.onOpenModel(content, "xl");
        this.fetchProviders();
        this.buildProviderAssigningForm();
        if (this.demographData[0].status != "Verified") {
            this.doctorDropDown = true;
        }
        else {
            this.doctorDropDown = false;
        }
        setTimeout(() => {
            this.callwhenAfterProvidersLoaded();
        }, 1000)


    }
    callwhenAfterProvidersLoaded(newLabBookingDetailId?: number) {
        if (newLabBookingDetailId) {
            this.newLabBookingDetailId = newLabBookingDetailId;
        }
        this.provideredit = true;
        this.httpService.get(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchDoctorsAssigned), { newLabBookingDetailId: this.newLabBookingDetailId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingDoctorSignatures = false))
            .subscribe((response: any) => {
                this.providerAssigned = response;
                for (let i = 0; i < response.length; i++) {
                    var result = this.providers.filter(item => item.id != response[i].approvedBy);
                    this.providers = result;
                }

                //var result = this.providers.filter(item => item.id != response[0].approvedBy);
                //let abc = response.map(x => x.approvedBy)
                //this.providerAssigningForm.get("approvedBy").setValue(abc);
                //this.providers = result;
            });
    }
    private buildProviderAssigningForm() {
        this.providerAssigningForm = this.formBuilder.group({
            approvedBy: [null, [Validators.required]],
            departmentId: [null],
            specializationId: [null],
            providerLocationId: [null],
            locationIds: [null],
            labReportVerificationId: 0
        })
        //if (this.providerAssigned != null || this.providerAssigned != undefined) {
        //    for (let i = 0; i < this.providerAssigned.length; i++) {
        //        this.providerAssigningForm.patchValue({
        //            approvedBy: this.providerAssigned[i].providerId,
        //        });
        //    }
        //}


        //this.providerAssigningForm.get("locationIds").valueChanges.subscribe((value: number) => {
        //    if (value) {
        //        this.fetchDoctorSpecialization(null, value)
        //        this.providerAssigningForm.get("specializationId").setValue(null);
        //    }
        //})

    }

    private buildTechForm(id: number) {
        this.techForm = this.formBuilder.group({
            technicianId: this.page.userAccount.accountId,
            newLabBookingDetailId: id,
            technicianComment: [null, [Validators.required]]
        })
    }

    get forms() {
        return {
            //popUp: this.popUpForm ? this.popUpForm.controls : {},
            providerSchedule: this.providerAssigningForm ? this.providerAssigningForm.controls : {},
            tech: this.techForm ? this.techForm.controls : {},
            //reschedulePopUp: this.reschedulePopUpForm ? this.reschedulePopUpForm.controls : {}
        }
    }
    customSearch(term: string, item) {
        term = term.toLocaleLowerCase();
        return item['value'].toLocaleLowerCase().indexOf(term) > -1 || item['optionalText'].toLocaleLowerCase().indexOf(term) > -1;
    }
    fetchDoctorSpecializationHelper($event: any) {
        if ($event && $event.term && $event.term.length >= 2) {
            let locationId = this.providerAssigningForm.get("locationIds").value
            this.fetchDoctorSpecialization($event.term, locationId);
        } else {
            this.providerSpecialization = new Array<ProviderSpecialization>();
        }
    }
    private fetchDoctorSpecialization(providerId?: string, locationId?: number) {
        this.loading = true;
        var request = {
            filter: providerId,
            locationId: locationId
        }

        this.httpService
            .post<Array<ProviderSpecialization>>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.fetchDoctorSpecialization), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe(
                (response: Array<ProviderSpecialization>) => {
                    this.providerSpecialization = response;
                },
                () => {
                    this.providerSpecialization = new Array<ProviderSpecialization>();
                }
            );
    }
    onChangeProvider(event: any) {

        if (event.length >= 1) {
            //const res = event.map((id) => this.providerSpecialization.find((o) => o.specializationId === id));
            let result = event.map(a => a.id);
            //var specialization = value.forEach(x => { x = this.providerSpecialization.find(m => m.specializationId = x) })
            this.providerAssigningForm.get("approvedBy").setValue(result);
            //this.fetchProviderSchedule();
            //this.draggableEvent = true;
        }
        else {
            //window.location.reload();
            this.notifyService.warningToast("Please select provider");
            //this.fullcalendar.calendar.destroy();

            //this.calendarOptions = undefined;
        }
        //this.providerId = event.providerId;
        //this.providerScheduleForm.patchValue({
        //    departmentId: event.departmentId,
        //    specializationId: event.specializationId
        //});
    }
    assignDoctors() {
        if (!this.providerAssigningForm.valid) {
            this.notifyService.warningToast("Please Select Doctor");
            return;
        }
        this.loadingproviderAssigning = true;
        const request = this.providerAssigningForm.getRawValue();
        request["newLabBookingDetailId"] = this.newLabBookingDetailId;
        request["Active"] = false;
        request["createdBy"] = this.page.userAccount.accountId;
        request["locationId"] = this.page.userAccount.locationId;
        this.httpService
            .post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.assignToDoctor), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingproviderAssigning = false))
            .subscribe(
                (response: number) => {
                    if (response >= 0) {
                        this.doctorAssigned = true;
                        this.notifyService.successToast("Assigned to respective Doctor's");
                        this.onCloseModal();
                        this.fetchTimeline();
                        this.onFetchDemographData();
                    }
                    else {
                        this.notifyService.warningToast("There is an error in Assigning to doctor");
                    }
                },
                () => {
                    //this.providerSpecialization = new Array<ProviderSpecialization>();
                }
            );

    }

    onRemove(event: any) {
        if (this.demographData[0].status == "Verified" || this.demographData[0].status == "DoctorAssigned" || this.demographData[0].status == "DoctorVerified") {
            this.providers.push(event.value.id);
            //this.providers = [...this.providers];
            //if (this.providers.some((condition) => condition == event.value.id)) {
            //    this.providers.push(event.value);
            //    this.providers = [...this.providers];
            //}
        }
    }

    onDeleteAssignedDoctor(provider: LabReportSignature) {
        const request = {
            labReportVerificationId: provider.labReportVerificationId,
            createdBy: this.page.userAccount.accountId,
            status: this.demographData[0].status,
            testName: this.demographData[0].testName,
            newLabBookingDetailId: this.newLabBookingDetailId
        };
        if (!request.labReportVerificationId || !request.createdBy || !request.status || !request.testName || !request.newLabBookingDetailId) {
            return this.notifyService.warningToast("Please Select Provider to delete The Assignment of that Lab Report");
        }
        this.httpService
            .post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.removeDoctor), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingproviderAssigning = false))
            .subscribe(
                (response: number) => {
                    if (response >= 0) {
                        this.notifyService.successToast("Removed Doctor Assignment for this Lab Report Succesfully");
                        this.onCloseModal();
                        this.fetchTimeline();
                        this.onFetchDemographData();
                    }
                    else {
                        this.notifyService.warningToast("There is an error in removing the doctor");
                    }
                },
                () => {
                    //this.providerSpecialization = new Array<ProviderSpecialization>();
                }
            );

    }
    viewPreviousResultsAdded(content: TemplateRef<any>) {
        var start = 0;
        var arr2 = [];

        this.loadingObservedValues = true;
        const request = {
            newLabBookingDetailId: this.newLabBookingDetailId
        };
        this.httpService
            .post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchallobservedvalues), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingObservedValues = false))
            .subscribe(
                (response: Array<LabObservedValueModel>) => {
                    this.totalObservedValues = response;
                    const distinctThings = this.totalObservedValues.filter(
                        (x, i, arr) => arr.findIndex(t => t.parameterName === x.parameterName) === i
                    );
                    this.parameterNames = distinctThings;
                    var end = this.totalObservedValues[0].count;
                    var count = this.totalObservedValues[0].count;
                    for (let i = 0; i < this.totalObservedValues.length / count; i++) {
                        arr2.push(this.totalObservedValues.slice(start, end))
                        start = end;
                        end = end + count;
                    }
                    this.totalObservedValues2 = arr2;
                },
                () => {
                    this.totalObservedValues = new Array<LabObservedValueModel>();
                    this.loadingObservedValues = false
                }
            );
        this.onOpenModel(content, "xl");
    }
    onViewReportNew(content: TemplateRef<any>) {
        this.showLabReport = true;
        this.onOpenModel(content, "xl");
        this.currentDate = new Date();
    }
    onViewDocument1(content: TemplateRef<any>) {
        this.showLabDocument = true;
        this.onOpenModel(content, "xl");
        this.currentDate = new Date();
    }
    onCloseExtraPopup() {
        this.showLabReport = false;
        this.showLabDocument = true;
        try {
            this.modalRef.close();
            this.modalRef = undefined;
            this.totalObservedValues2 = null;
            this.totalObservedValues = null;

        } catch (e) {
            // ignored;
        }
    }
    onOpenUploadFile(content: TemplateRef<any>/*, recordDetail: LabBillDetailModel*/) {
        this.onOpenModel(content, "xl");
        this.onResetFileUploader();
        //this.selectedLabBookingDetail = recordDetail;
    }
    onResetFileUploader() {
        this.loadingFile = false;
        this.documentError = false;
        this.fileName = null;
        this.formedUrl = null;
        this.uploadedFile = null;
        this.fileUploadFail = false;
    }

    onUploadReport() {
        const request = {
            ...this.selectedLabBookingDetail,
            uploadedBy: this.page.userAccount.accountId
        };
        request["roleId"] = this.page.userAccount.roleId;
        request["createdByName"] = this.page.userAccount.fullName;
        request["requisitionNumber"] = this.demographData[0].requisitionNumber;
        request["locationId"] = this.page.userAccount.locationId;
        const formData = UtilHelper.prepareFormData(UtilHelper.clone(request));
        formData.append(`File${1}`, this.uploadedFile, this.uploadedFile.name);
        this.isUploading = true;
        this.httpService.postFile(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.uploadLabData), formData)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => {
                this.isUploading = false;
                this.onCloseModal();
            }))
            .subscribe((res: string) => {
                this.notifyService.successToast(res);
                this.fetchLabBookingDetail();
                //this.fetchLabsBooked();
                this.onResetFileUploader();
                //this.selectedLabBookingDetail = new LabBillDetailModel();
            }, (error: HttpErrorResponse) => {
                const errorMessage = UtilHelper.handleError(error);
                if (errorMessage) {
                    this.notifyService.warningToast(errorMessage);
                } else {
                    this.notifyService.defaultError();
                }
            });
    }

    private fetchNewLabBookingDetail() {
        this.loadingTimeline = true;
        this.httpService.get(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchNewLabBookingDetail), { encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingTimeline = false))
            .subscribe((response: LabBillDetailModel) => {
                this.selectedLabBookingDetail = response;
            }, () => {
                this.notifyService.warningToast("Unable to fetch lab Booking detail.");
            });
    }
    fetchLabBookingDetail() {
        const request = {
            encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId,
            ... this.selectedLabBookingDetail
        };
        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchLabBookingDetail), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe(
                (response: LabBillDetailModel) => {
                    this.records = response;
                    this.documentUrl = this.records.reportUrl;
                    this.isExternalDocument = false;
                    this.checkExternalDocument();
                });
    }
    private checkExternalDocument() {
        if (this.records && UtilHelper.isEmpty(this.documentUrl)) {
            this.loading = true;
            this.isExternalDocument = true;
            this.httpService
                .post(ApiResources.getURI(ApiResources.documents.base, ApiResources.documents.downloadFile), { documentUrl: this.documentUrl })
                .pipe(takeUntil(this.page.unSubscribe))
                .subscribe(
                    (response: any) => {
                        this.reportData = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64, ${response.base64}`);
                        this.reportDataWithoutAuth = `data:application/pdf;base64, ${response.base64}`;


                    }
                );
        }
    }
    onFileUpload(event) {
        this.loadingFile = true;
        this.uploadedFile = event.target.files[0];
        this.fileUploadFail = false;
        this.fileName = this.uploadedFile.name;
        let extension = this.uploadedFile.name.split(".").pop();
        if (extension === "pdf") {
            this.fileChangeEvent();
        }
        else {
            this.loadingFile = false;
            this.uploadedFile = null;
            this.fileUploadFail = true;
        }
    }

    fileChangeEvent() {
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        }


        getBase64(this.uploadedFile).then((data: any) => {
            this.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data);
            this.loadingFile = false;
        }, () => {
            this.uploadedFile = null;
            this.fileUploadFail = true;
            this.loadingFile = false;
            this.formedUrl = null;
        });
    }

    onProgress(progressData: ProgressData) {
        if (progressData.loaded === progressData.total) {
            this.loadingFile = false;
        }
    }
    onProgressPfd(progressData: ProgressData) {
        this.isExternalLoading = true;
        if (progressData.loaded === progressData.total) {
            this.isExternalLoading = false;
        }

    }
    onDocumentError() {
        this.loadingFile = false;
        this.documentError = true;
    }

    onOpenTechForm(content: TemplateRef<any>) {
        this.showLabReport = true;
        const BreakError = {};
        try {
            const templates = this.parameters.templates;
            this.parameterInput = new Array<TempParameter>();
            this.templateInput = new Array<TemplateInput>();
            templates.forEach((template) => {
                if (template.isMethod) {
                    if (UtilHelper.isEmpty(template.methodText) && UtilHelper.isEmpty(template.methodText.trim())) {
                        // ignore
                    } else {
                        this.notifyService.warning(`Please enter method text for template ${template.templateName}`);
                        throw BreakError;
                    }
                }
                

                template.components.forEach((component: LabComponentHeaderForInput) => {
                    var abnormalIndex = component.parameters.findIndex(param => param.showText == "H" || param.showText == "L");
                    if (abnormalIndex > -1) {
                        this.isAbnormal = true;
                    } else {
                        this.isAbnormal = false;
                    }
                    component.parameters.forEach((parameter: LabParameterInputHeaderModel) => {
                        if (parameter.type === "Regular") {
                            if (!UtilHelper.isEmpty(parameter.observedValue)) {
                                this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                throw BreakError;
                            }
                            else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                                this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                                throw BreakError;
                            }
                        }
                        else {
                            parameter.antibiotics.forEach((antibiotic: LabParameterInputHeaderModel) => {
                                if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                    throw BreakError;
                                }
                                else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                    this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                    throw BreakError;
                                }
                            });
                        }
                        
                    });
                });
                var abnormalIndex = template.parameters.findIndex(param => param.showText == "H" || param.showText == "L");
                if (abnormalIndex > -1) {
                    this.isAbnormal = true;
                } else {
                    this.isAbnormal = false;
                }
                template.parameters.forEach((parameter: LabParameterInputHeaderModel) => {
                    if (parameter.type === "Regular") {
                        if (!UtilHelper.isEmpty(parameter.observedValue)) {
                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                            throw BreakError;
                        }
                        else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                            throw BreakError;
                        }
                    }
                    else {
                        parameter.antibiotics.forEach((antibiotic: LabParameterInputHeaderModel) => {
                            if (!UtilHelper.isEmpty(antibiotic.observedValue)) {
                                this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                throw BreakError;
                            }
                            else if (!UtilHelper.isEmpty(antibiotic.observedValue.trim())) {
                                this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName} <i class="mdi mdi-arrow-right"></i> <b>Antibiotic</b> ${antibiotic.antibioticName}`);
                                throw BreakError;
                            }
                        });
                    }
                    
                });


            });
        }
        catch (err) {
            if (err !== BreakError) throw err; return;
        }


        if (this.demographData[0].assignDoctorRequired && !this.doctorAssigned && this.providerAssigned.length == 0) {
            this.notifyService.info("For this Test Assign Doctor is required", () => {

            });
        }
        else {
            this.buildTechForm(this.selectedLabBookingDetail.newLabBookingDetailId);
            this.onOpenModel(content, "lg");
        }


    }

    onVerifyByTechnician() {
        this.submitted = true;

        const req = this.techForm.getRawValue();
        req["roleId"] = this.page.userAccount.roleId;
        req["createdByName"] = this.page.userAccount.fullName;
        req["testName"] = this.demographData[0].testName;
        req["requisitionNumber"] = this.demographData[0].requisitionNumber;
        req["locationId"] = this.page.userAccount.locationId;
        this.submitting = true;

        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.addTechnicianVerification), req)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.submitted = this.submitting = false))
            .subscribe((response: number) => {
                if (response > 0) {
                    this.notifyService.successToast("Lab technician verified successfully.");
                    this.onCloseModal();
                    this.fetchTimeline();
                    this.fetchNewLabBookingDetail();
                }
            }, () => {
                this.notifyService.warningToast("Unable to verify.");
            });

    }

    onSubmitVerify() {
        this.isVerify = true;
        if (this.showButton) {
            this.onVerifyByTechnician();
            //if (this.page.userAccount.roleId == 3) {
            //    this.onDoctorVerified();
            //} else {
                
            //}
        } else {
            this.onSubmit();
        }
    }
    changeTextColor(param: LabParameterInputHeaderModel) {
        if (param.observedValue == "" || !param.observedValue) {
            param.showText = null;
            param.isBold = false;
            return;
        }
        let observedValue;
        if ((param.observedValue[0] == ">" || param.observedValue[0] == "<") && param.observedValue.length > 1) {
            var value = param.observedValue[0];
            observedValue = +param.observedValue.substring(1)
            if (value == ">") {
                observedValue = observedValue + 1;
            } else if (value == "<") {
                observedValue = observedValue - 1;
            }
        } else {
             observedValue = +param.observedValue;
        }
        let range = param.selected;
        if (range != null) {
            let exactRange = range;
            param.showText = null;
            param.isBold = false;
            if (exactRange.minValue > observedValue) {
                param.showText = "L";
                param.isBold = true;
            }
            else if (observedValue > +exactRange.maxValue) {
                param.showText = "H";
                param.isBold = true;
            }
        }
    }
    onPrintPdf() {
        let printIframe;
        let blobUrls = [];
        let data = this.reportDataWithoutAuth;

        async function printMethod() {
            const resp = await fetch(data);
            const blob = await resp.blob();
            const url = URL.createObjectURL(blob);
            blobUrls.push(url);
            if (!printIframe) {
                printIframe = document.createElement('iframe');
                printIframe.setAttribute("id", "myDOC");
                document.body.appendChild(printIframe);

                printIframe.style.position = 'absolute';
                printIframe.style.top = '0';
                printIframe.style.left = '-1000px';

                printIframe.onload = () => {
                    setTimeout(() => {
                        if (printIframe) {
                            printIframe.focus();
                            printIframe.contentWindow.print();
                        }
                    }, 100)
                }
            }
            printIframe.src = url;
        }

        printMethod();
    }


    onChangePrintType(type: boolean) {
        this.isPrintLogo = type;
    }
    private inactiveDocument() {
        const request = {
            newLabBookingDetailId: this.newLabBookingDetailId,
            reportUrl: this.documentUrl,

        };
        this.notifyService.confirm("Do you really want to delete this Document? This process can not be undone.", () => {
            this.httpService
                .post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.inactiveLabDocument), request)

                .pipe(takeUntil(this.page.unSubscribe))
                .subscribe({
                    next: () => {
                        this.notifyService.successToast("The document got deleted sucessfully");
                        this.fetchLabBookingDetail();
                        this.onCloseModal();
                    },
                    error: (error: HttpErrorResponse) => {
                        this.errorMessage = UtilHelper.handleError(error);
                        this.notifyService.warning(this.errorMessage);
                    }
                });
        });
    }
    onDeleteDocument() {
        this.inactiveDocument();
    }
    private FetchInputParameters() {
        const request = {
            encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId,
            fromTech: "tech"
        };
        this.loading = true;
        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.labParameterForInput), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: LabParameterInputModel) => {
                this.parametersDummy = response;
                this.labMainDetailId = this.parameters.labMainDetailId;
                this.reportsDummy = new LabParameterInputModel();
                this.reportsDummy = UtilHelper.clone(this.parametersDummy);
                this.reportsDummy.templates = new Array<LabTemplateHeaderForInput>();
                this.parametersDummy.templates.forEach((template: LabTemplateHeaderForInput) => {
                    let parameterList = new Array<LabParameterInputHeaderModel>();
                    template.components.forEach((component: LabComponentHeaderForInput) => {
                        component.parameters.forEach((param: LabParameterInputHeaderModel) => {
                            if (param.observedValue == "" || !param.observedValue) {
                                param.showText = null;
                                param.isBold = false;
                            } else {
                                let observedValue = +param.observedValue;
                                let range = param.selected;
                                if (range != null) {
                                    let exactRange = range;
                                    if (exactRange.minValue > observedValue) {
                                        param.showText = "L";
                                        param.isBold = true;
                                        this.isAbnormal = true;
                                    }
                                    else if (observedValue > +exactRange.maxValue) {
                                        param.showText = "H";
                                        param.isBold = true;
                                        this.isAbnormal = true;
                                    }
                                }
                            }
                            if (param.type == "Regular") {
                                parameterList.push(param);
                            }
                            else if (param.type == "Microbiology") {
                                var resultAddedAntibiotics = param.antibiotics.filter(x => x.observedValue != null);
                                if (resultAddedAntibiotics.length > 0) {
                                    param.antibiotics = resultAddedAntibiotics;
                                    parameterList.push(param);
                                } else {
                                    parameterList.push(param);
                                }

                            }
                        });
                    });
                    template.parameters.forEach((param: LabParameterInputHeaderModel) => {
                        if (param.observedValue == "" || !param.observedValue) {
                            param.showText = null;
                            param.isBold = false;
                        } else {
                            let observedValue = +param.observedValue;
                            let range = param.selected;
                            if (range != null) {
                                let exactRange = range;
                                if (exactRange.minValue > observedValue) {
                                    param.showText = "L";
                                    this.isAbnormal = true;
                                    param.isBold = true;
                                }
                                else if (observedValue > +exactRange.maxValue) {
                                    param.showText = "H";
                                    this.isAbnormal = true;
                                    param.isBold = true;
                                }
                            }
                        }
                        if (param.type == "Regular") {
                            parameterList.push(param);
                        }
                        else if (param.type == "Microbiology") {
                            var resultAddedAntibiotics = param.antibiotics.filter(x => x.observedValue != null);
                            if (resultAddedAntibiotics.length > 0) {
                                param.antibiotics = resultAddedAntibiotics;
                                parameterList.push(param);
                            } else {
                                parameterList.push(param);
                            }

                        }
                    });
                    this.reportsDummy.templates.push(template);
                });
            });
    }
    onChange() {
        this.showButton = true;
        this.parameters.templates.forEach((item) => {
            item.parameters.forEach((param) => {
                this.parametersDummy.templates.forEach((m) => {
                    var index = m.parameters.findIndex(n => n.labParameterHeaderId == param.labParameterHeaderId && n.observedValue != param.observedValue && param.observedValue != "");
                    m.parameters?.forEach((y) => {
                        param.antibiotics?.forEach((antibio) => {
                            var subindex1 = y.antibiotics?.findIndex(bio => bio.labAntibioticsId == antibio.labAntibioticsId && bio.labParameterHeaderId == antibio.labParameterHeaderId);
                            if (subindex1 == -1) {
                                this.showButton = false;
                                return;
                            }
                        })
                        y.antibiotics?.forEach((anti) => {
                            var subIndex = param.antibiotics?.findIndex(x => x.observedValue != anti.observedValue && x.labParameterHeaderId == anti.labParameterHeaderId && x.labAntibioticsId == anti.labAntibioticsId);
                            if (subIndex > -1) {
                                this.showButton = false;
                                return;
                            }
                        })
                    })
                    if (index > -1) {
                        this.showButton = false;
                        return;
                    }
                })
            })
            item.components.forEach((component) => {
                this.parametersDummy.templates.forEach((m) => {
                    m.components.forEach((data) => {
                        data.parameters.forEach((params) => {
                            var index = component.parameters.findIndex(n => n.labParameterHeaderId == params.labParameterHeaderId && n.observedValue != params.observedValue && params.observedValue != "")
                            params.antibiotics?.forEach((anti) => {
                                component?.parameters?.forEach((param) => {
                                    var subIndex = param.antibiotics?.findIndex((x => x.observedValue != anti.observedValue && x.labParameterHeaderId == anti.labParameterHeaderId && x.labAntibioticsId == anti.labAntibioticsId));
                                    if (subIndex > -1) {
                                        this.showButton = false;
                                        return;
                                    }
                                })
                            })
                            if (index > -1) {
                                this.showButton = false;
                                return;
                            }
                        })
                    })
                })
            })
            var index = this.parametersDummy.templates.findIndex(Y => Y.methodText != item.methodText || Y.interpretationText != item.interpretationText);
            if (index > -1) {
                this.showButton = false;
                return;
            }
        })
    }

    private buildForm(document?: LabDocumentsDetails) {
        this.uploadForm = this.formBuilder.group({
            documentsDetailId: [document && document.documentDetailsId ? document.documentDetailsId : 0, [Validators.required]],
            documentName: [document && document.documentName ? document.documentName : "", [Validators.required]],
            description: [document && document.description ? document.description : null]
        });
    }
    onCloseModalViewDocument() {
        if (this.modalRefViewDocument) {
            this.modalRefViewDocument.close();
            this.modalRefViewDocument = undefined;
        }
    }
    private fetchDocuments() {
        this.loading = true;
        const request = Object.assign(UtilHelper.clone(this.pagination));
        this.patientId = this.demographData[0]?.patientId;
        request["PatientId"] = this.demographData[0].patientId;
        request["encryptedPatientId"] = this.encryptedPatientId ? this.encryptedPatientId : null;
        this.httpService.post(ApiResources.getURI(ApiResources.labDocumentDetails.base, ApiResources.labDocumentDetails.fetch), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => { this.loading = false }))
            .subscribe((response: Array<LabDocumentsDetails>) => {
                this.documents = response;
                if (this.documents.length == 0) {
                    this.showReport = false;
                } else {
                    this.showReport = true;
                    this.patientId = this.documents[0]?.patientId;
                }
            });
    }
    onViewMultiplDocument(content: TemplateRef<any>) {
        this.onOpenLabMultipleReportModelForDoc(content, "xl")
    }
    onOpenLabMultipleReportModelForDoc(content: TemplateRef<any>, size: string) {
        this.modalRefViewDocument = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            size: size,
            windowClass: "custom-modal effect-scale"
        });
    }
    onUploadDocument() {
        this.submitted = true;
        if (!this.uploadForm.valid || this.warningMessage) {
            this.notifyService.info("Please Enter the document name ");
            return;
        }
        this.errorMessage = undefined;
        this.submitting = true;
        const model = UtilHelper.clone(this.uploadForm.value);

        if (model) {
            const formData = new FormData();

            formData.append("PatientId", this.demographData[0].patientId.toString());
            formData.append("UploadedBy", this.page.userAccount.accountId.toString());
            formData.append("DocumentName", model["documentName"]);
            formData.append("NewLabBookingDetailId", this.demographData[0].newLabBookingDetailId.toString());
            formData.append("Description", model["description"]);

            const files = this.files;

            if (!files || !files.length) {
                this.submitting = false;
                this.notifyService.info("Please select at least one file");
                return;
            }

            const n = files.length;
            if (n > this.maxFiles) {
                files.splice(this.maxFiles, files.length);
            }

            files.forEach((file: File, index: number) => {
                formData.append(`File${index + 1}`, file, file.name);
            });

            this.httpService
                .postFile(ApiResources.getURI(ApiResources.labDocumentDetails.base, ApiResources.labDocumentDetails.upload), formData)
                .pipe(finalize(() => { this.submitted = false; this.submitting = false; }))
                .pipe(takeUntil(this.page.unSubscribe))
                .subscribe(
                    () => {
                        this.files = [];
                        this.notifyService.successToast("Document uploaded successfully.");
                        this.onCloseModal();
                        this.onCloseModalDocument();
                        this.onMutipleDocumetCloseModel();
                        this.fetchDocuments();
                    },
                    (error: HttpErrorResponse) => {
                        this.errorMessage = UtilHelper.handleError(error);
                        this.notifyService.warning(this.errorMessage);
                    }
                );
        }
    }
    onMutipleDocumetCloseModel() {
        if (this.modalRefViewDocument) {
            this.closeModelFunction(this.modalRefViewDocument);
        }
    }
    closeModelFunction(model) {
        model.close();
        model = undefined;
    }
    onFileSelect(files: Array<File>) {
        this.files = files;
    }
    onCloseModalDocument() {
        if (this.modalRefDocument) {
            this.modalRefDocument.close();
            this.modalRefDocument = undefined;
        }
    }
    onPrevious() {
        let index = this.documents.findIndex((m => m.documentDetailId === this.document.documentDetailsId) as any);
        index = index - 1;
        this.showPrevious = index !== 0;
        this.showNext = true;
        this.document = undefined;
        this.prepareDocument(this.documents[index]);
    }
    onNext() {
        let index = this.documents.findIndex((m => m.documentDetailsId === this.document.documentDetailsId) as any);
        index = index + 1;
        this.showNext = index !== this.documents.length - 1;
        this.showPrevious = true;
        this.document = undefined;
        this.prepareDocument(this.documents[index]);
    }
    private prepareDocument(document: LabDocumentsDetails) {
        this.loadingDocument = true;
        this.document = document;
        this.documentError = false;
        this.document.isImage = this.document.contentType.indexOf("pdf") < 0 && this.document.contentType.indexOf("video") < 0;
        this.document.isVideo = this.document.contentType.indexOf("video") >= 0;
        if (this.document.isImage || this.document.isVideo) {
            this.loadingDocument = true;
            this.document.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${ApiResources.getURI(ApiResources.labDocumentDetails.base, ApiResources.labDocumentDetails.downloadFileGet)}?id=${this.document.documentDetailsId}&url=${this.document.documentUrl}`);
            if (this.document.formedUrl) {
                this.loadingDocument = true;
            }
        }
        if (!this.document.isImage && !this.document.isVideo) {
            this.httpService
                .post(ApiResources.getURI(ApiResources.labDocumentDetails.base, ApiResources.labDocumentDetails.downloadFile), { ...document })
                .pipe(takeUntil(this.page.unSubscribe))
                .pipe(finalize(() => { this.loadingDocument = false; }))
                .subscribe(
                    (response: LabDocumentsDetails) => {
                        this.document.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64, ${response.base64}`);
                    }
                );

        } else {
            this.loadingDocument = false;
        }
    }

    onDocumentLoad() {
        this.loadingDocument = false;
    }
    onOpenModalView(content: TemplateRef<any>, document?: LabDocumentsDetails) {

        this.prepareDocument(document);
        const index = this.documents.findIndex((m => m.documentDetailsId === this.document.documentDetailsId) as any);
        if (index === 0 && this.documents.length === 1) {
            this.showPrevious = false;
            this.showNext = false;
        } else if (index === 0) {
            this.showPrevious = false;
            this.showNext = true;
        } else if (index === this.documents.length - 1) {
            this.showPrevious = true;
            this.showNext = false;
        } else {
            this.showPrevious = true;
            this.showNext = true;
        }
        this.modalRef = this.modalService.open(content, {
            keyboard: false,
            centered: true,
            windowClass: "document-view-modal custom-modal effect-scale"
        });


    }
    onDelete(document: LabDocumentsDetails) {
        const request =
        {
            documentDetailsId: document.documentDetailsId,
            patientId: document.patientId,
            documentUrl: document.documentUrl,
            newLabBookingDetailId: document.newLabBookingDetailId,
            uploadedBy: this.page.userAccount.accountId,
            modifiedBy: this.page.userAccount.accountId,
            loginRoleId: this.page.userAccount.roleId,
            loginAccountId: this.page.userAccount.accountId,
        }
        this.document = document;
        this.modifyingContent = " Deleting the selected document";
        this.notifyService.delete(() => {
            this.modifying = true;
            this.httpService
                .post(ApiResources.getURI(ApiResources.labDocumentDetails.base, ApiResources.labDocumentDetails.delete), request)
                .pipe(takeUntil(this.page.unSubscribe))
                .pipe(finalize(() => { this.modifying = false; this.document = undefined }))
                .subscribe(
                    () => {
                        this.notifyService.successToast("Document deleted successfully.");
                        this.fetchDocuments();
                    }
                );
        });
    }

    onCloseModalView() {
        if (this.modalRefView) {
            this.modalRefView.close();
            this.modalRefView = undefined;
        }
    }

    OpenView(content, size) {
        this.modalRefView = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            windowClass: "custom-modal effect-scale",
            size: size
        });
    }

    onViewDocument(content: TemplateRef<any>) {
        this.onOpenLabReportModelForDoc(content, "xl");
    }

    onOpenLabReportModelForDoc(content: TemplateRef<any>, size: string) {
        this.modalRefView = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            size: size ? size : "lg",
            windowClass: "custom-modal effect-scale"
        });
    }

    onOpenModalMultiple(content: TemplateRef<any>, size?: string, document?: LabDocumentsDetails) {
        if (!content) {
            console.error('Template content is undefined');
            return;
        }

        this.modalRefViewDocument = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            windowClass: "custom-modal effect-scale",
            size: size
        });

        this.buildForm(document);
    }
    removeAntibiotic(parameter: LabParameterInputHeaderModel, index: number, TemplateIndex: number, paramIndex: number, componentParamIndex?: number) {
       
        if (parameter.antibiotics[index].observedValue) {
            var oldAntibiotic;
            if (componentParamIndex == undefined) {
                oldAntibiotic = this.parametersDummy.templates[TemplateIndex].parameters[paramIndex].antibiotics?.find(x => x.labAntibioticsId == parameter.antibiotics[index].labAntibioticsId);
                if (oldAntibiotic) {
                    if (oldAntibiotic.observedValue) {
                        this.showButton = false;
                    }
                } else {
                    this.showButton = true;
                }
            } else {
                oldAntibiotic = this.parametersDummy.templates[TemplateIndex].components[componentParamIndex].parameters[paramIndex].antibiotics?.find(x => x.labAntibioticsId == parameter.antibiotics[index].labAntibioticsId);
                if (oldAntibiotic) {
                    if (oldAntibiotic.observedValue) {
                        this.showButton = false;
                    }
                } else {
                    this.showButton = true;
                }
            }
        }
        if (parameter == null || parameter == undefined) {
            return this.notifyService.warningToast('unable to remove this Antibiotic');
        }
        if (parameter.labParameterObservedValueId != 0) {
            parameter.antibiotics.splice(index, 1);
            return this.notifyService.warningToast('Antibiotic Deleted Succesfully.');
        } else {
            parameter.antibiotics.splice(index, 1);
            return this.notifyService.warningToast('Antibiotic Removed Succesfully.');

        }
    }
    onClickMicroParameter(data: LabParameterInputHeaderModel, index: number, paramIndex: number, componentParamIndex?: number) {
        this.selectParameter = data.antibioticName;
        var indexvalue;
        if (componentParamIndex == undefined) {
             indexvalue = this.reports.templates[index].parameters[paramIndex].antibiotics.findIndex(x => x.antibioticName == data.antibioticName);
        } else {
            indexvalue = this.reports.templates[index].components[componentParamIndex].parameters[paramIndex].antibiotics.findIndex(x => x.antibioticName == data.antibioticName);
        }
        if (indexvalue > -1) {
            this.notifyService.warningToast('Antibiotic Already Exist.');
        } else {
            data.observedValue = null;
            if (componentParamIndex == undefined) {
                this.reports.templates[index].parameters[paramIndex].antibiotics.push(data);
            } else {
                this.reports.templates[index].components[componentParamIndex].parameters[paramIndex].antibiotics.push(data);
            }
            this.notifyService.successToast('Antibiotic Added Succesfully.');
        }
        var oldAntibiotic;
        this.showButton = true;
        if (componentParamIndex == undefined && indexvalue == -1) {
            oldAntibiotic = this.reportsDummy.templates[index].parameters[paramIndex].antibiotics?.find(x => x.labAntibioticsId == data.labAntibioticsId);
            if (oldAntibiotic) {
                if (oldAntibiotic.observedValue) {
                    this.showButton = false;
                  
                }
            } else {
                this.showButton = false;

            }
        } else if (indexvalue == -1) {
            oldAntibiotic = this.reportsDummy.templates[index].components[componentParamIndex].parameters[paramIndex].antibiotics?.find(x => x.labAntibioticsId == data.labAntibioticsId);
            if (oldAntibiotic) {
                if (oldAntibiotic.observedValue) {
                    this.showButton = false;

                }
            } else {
                this.showButton = false;

            }
        }

    }

    private findLabAntibiotic() {
        const request = {};
        this.httpService.post<any>(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchLabAntiBiotic), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: Array<LookUpValue>) => {
                if (response.length > 0) {
                    this.labAntibiotics = new Array<LabParameterInputHeaderModel>();
                    response.forEach((antibiotic) => {
                        var loadAntibiotic = new LabParameterInputHeaderModel();
                        loadAntibiotic.antibioticName = antibiotic.name;
                        loadAntibiotic.labAntibioticsId = antibiotic.lookupValueId;
                        this.labAntibiotics.push(loadAntibiotic);
                    });
                }

            });
    }
    onChangeAntibiotics(templateIndex: number, parameterIndex: number, antibioticsIndex: number, componentParamIndex?: number) {
        var newValue;
        var oldValue
        if (componentParamIndex == undefined) {
            newValue = this.reports.templates[templateIndex].parameters[parameterIndex].antibiotics[antibioticsIndex].observedValue;
            oldValue = this.reportsDummy.templates[templateIndex].parameters[parameterIndex].antibiotics[antibioticsIndex].observedValue;
        } else {
            newValue = this.reports.templates[templateIndex].components[componentParamIndex].parameters[parameterIndex].antibiotics[antibioticsIndex].observedValue;
            oldValue = this.reportsDummy.templates[templateIndex].components[componentParamIndex].parameters[parameterIndex].antibiotics[antibioticsIndex].observedValue;
        }
        if (newValue != oldValue && newValue !="") {
            this.showButton = false;
        } else {
            this.showButton = true;
        }
    }
    onViewPastLabReports(content: TemplateRef<any>) {
        this.patientPastLabReports = new Array<LabPastReportsModel>();
        this.onOpenModel(content, "xxl");
        this.initPagination1();
        this.fetchPatientPastlabReports(this.patientId, this.labMainDetailId, this.newLabBookingDetailId);

    }
    private fetchPatientPastlabReports(patientId: number, labMainDetailId: number, newLabBookingDetailId: number) {
        this.loadingPastLabReports = true;
        const request = {
            ...this.pagination1
        };
        request["patientId"] = patientId;
        request["labMainDetailId"] = labMainDetailId;
        request["newLabBookingDetailId"] = newLabBookingDetailId;
        this.httpService.post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchPatientPastLabReports), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingPastLabReports = false))
            .subscribe((response: Array<LabPastReportsModel>) => {
                this.patientPastLabReports = response;
                UtilHelper.applyPagination(this.patientPastLabReports, this.pagination1);
            }, () => {
                this.notifyService.warningToast("Unable to Past lab reports");
            });

    }
    onOpenLAbReport(lab: LabPastReportsModel) {
        this.router.navigate([]).then(() => { window.open(`${location.origin}${location.pathname}#/new-lab-reports/${lab.encryptedNewLabBookingDetailId}`, "_blank"); });
    }
    private initPagination1() {
        this.pagination1 = new Pagination();
        this.pagination.pageIndex = 1;
        this.pagination.pageSize = 20;
    }

    private fetchAntibioticResultTypes() {
        const request = {};
        this.httpService.post<any>(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchLabAntiBioticResultTypes), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: Array<LookUpValue>) => {
                this.labAntibioticsResultTypes = new Array<LookUpValue>();
                this.labAntibioticsResultTypes = response;
                if (response.length == 0) {
                    return this.notifyService.warningToast('Antibiotic Result Types not Found');
                }

            });
    }
    onDoctorVerified() {
        this.verifying = true;
        const request = {
            newLabBookingDetailId: this.newLabBookingDetailId
        };
        if (this.page.userAccount.roleId == 3) {
            request["doctorId"] = this.page.userAccount.referenceId;
            request["accountId"] = this.page.userAccount.accountId;
        }
        request["urlLink"] = window.location.href;
        request["patientId"] = this.demographData[0].patientId;
        request["testName"] = this.demographData[0].testName;
        request["roleId"] = this.page.userAccount.roleId;
        request["createdByName"] = this.page.userAccount.fullName;
        request["requisitionNumber"] = this.demographData[0].requisitionNumber;
        request["paymentStatus"] = this.demographData[0].paymentStatus;
        request["paymentType"] = this.demographData[0].paymentType;
        request["locationId"] = this.page.userAccount.locationId;

        this.httpService.post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.doctorVerifyReport), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.verifying = false))
            .subscribe((response: number) => {
                if (response > 0) {
                    this.notifyService.successToast(`Test Report Verified Successfully.`);
                    this.onClosePopup();
                }
                if (response < 0) {
                    this.notifyService.successToast(`error in Test Verification`);
                }

            }, () => {
                this.notifyService.warningToast("Unable to Test Verification.");
            });

    }

    onClosePopup() {
        this.onClose.emit();
    }
    OpenReasonView(content) {
        this.reason = null;
        this.modalReason = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: true,
            windowClass: "custom-modal effect-scale",
            size: 'm'
        });
    }
    onCloseReasonView() {
        if (this.modalReason) {
            this.modalReason.close();
            this.modalReason = undefined;
        }
    }
    onRemoveParameters() {
        if (!UtilHelper.isEmpty(this.reason)) {
            return this.notifyService.warning(`Please enter Reason`);
        }
        else if (!UtilHelper.isEmpty(this.reason.trim())) {
            return this.notifyService.warning(`Please enter Reason`);
        }
        const request = {
            encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId
        };
        request["reason"] = this.reason;
        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.removeparametervalues), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((response: number) => {
                if (response > 0) {
                    this.notifyService.successToast("The Parameters Removed sucessfully");
                    this.onCloseReasonView();
                    this.onClosePopup();
                }

            })
    }
    //private fetchDoctorVerifyDetail() {
    //    this.loadingTimeline = true;
    //    this.httpService.get(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.bookingdoctorverifydetail), { encryptedNewLabBookingDetailId: this.encryptedNewLabBookingDetailId })
    //        .pipe(takeUntil(this.page.unSubscribe))
    //        .pipe(finalize(() => this.loadingTimeline = false))
    //        .subscribe((response: Doctors) => {
    //            this.doctorDetails = response;
    //        }, () => {
    //            this.notifyService.warningToast("Unable to fetch lab Booking detail.");
    //        });
    //}
}